import axios from "axios"
import { toast } from "react-toastify"
import { login_f, login_r, login_s } from "./actiontypes"
import 'react-toastify/dist/ReactToastify.css';


const login=(payload)=>(dispatch)=>{
    dispatch({type:login_r})
    return axios.post('https://reqres.in/api/login',payload)
    .then((res)=>{
        dispatch({type:login_s,payload:res.data})
        console.log("res",res)
        if(res.data.token){
            toast.success('Login Successfull',{
                position:"top-center"
            })
        }
    }).catch((err)=>{
        dispatch({type:login_f})
        console.log(err)
    })
}
export {login}